import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'contratos', ptBr);
i18next.addResourceBundle('en', 'contratos', en);

const ContratoConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/vendas-servicos/contrato',
      component: React.lazy(() => import('./Contrato')),
    },
  ],
};

export default ContratoConfig;
